import { Box } from '@customerio/pluma-components/react';

/** Company step. Placeholder — content lands with the company step PR. */
export function CompanyStep() {
  return <Box data-testid="signup-step-company" />;
}
